// extracted by mini-css-extract-plugin
export default {"planConnector":"ConfirmStep_planConnector__pdus+","planConnectorIcon":"ConfirmStep_planConnectorIcon__Ou9sT"};